import { AfterContentInit, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentsService } from 'src/app/components.service';

@Component({
  selector: 'app-product-man-preview',
  templateUrl: './product-man-preview.component.html',
  styleUrls: ['./product-man-preview.component.css']
})
export class ProductManPreviewComponent implements OnInit, AfterContentInit {

  constructor(private service: ComponentsService, private router: Router, private activeRoute: ActivatedRoute) { }

  @ViewChild("matGroup") matGroup;

  index;
  loaded: boolean;

  ngOnInit(): void {
    this.service.refreshPage.subscribe(() => {
      // save current route first

      let index = this.matGroup._selectedIndex;
      const currentRoute = this.router.url;
      localStorage.setItem('userTabLocation', index);
      this.router.navigateByUrl(`/home`, { skipLocationChange: false }).then(() => {
        this.router.navigate([currentRoute]) // navigate to same route
      });
    })
  }
  ngAfterContentInit() {
    let index = localStorage.getItem('userTabLocation') || 0;
    this.index = index;
    this.loaded = true;
  }

}
